var map = {
	"./addliquidity.json": 1128,
	"./box.json": 1129,
	"./components.json": 1130,
	"./constants.json": 1131,
	"./error.json": 1132,
	"./farm.json": 1133,
	"./home.json": 1134,
	"./launchpad.json": 1135,
	"./menu.json": 1136,
	"./minning.json": 1137,
	"./nft.json": 1138,
	"./pool.json": 1139,
	"./referral.json": 1140,
	"./removeliquidity.json": 1141,
	"./rolling.json": 1142,
	"./swap.json": 1143,
	"./team.json": 1144,
	"./uikit.json": 1145
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1127;